import { render, staticRenderFns } from "./CommentIcon.vue?vue&type=template&id=4e1e9cab&scoped=true"
import script from "./CommentIcon.vue?vue&type=script&lang=ts"
export * from "./CommentIcon.vue?vue&type=script&lang=ts"
import style0 from "./CommentIcon.vue?vue&type=style&index=0&id=4e1e9cab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1e9cab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e1e9cab')) {
      api.createRecord('4e1e9cab', component.options)
    } else {
      api.reload('4e1e9cab', component.options)
    }
    module.hot.accept("./CommentIcon.vue?vue&type=template&id=4e1e9cab&scoped=true", function () {
      api.rerender('4e1e9cab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/CommentIcon.vue"
export default component.exports